module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26137",
      "conversations-internal-schema": "static-1.12618",
      "head-dlb": "static-1.4884",
      "hs-test-utils": "static-1.7883",
      "hubspot-url-utils": "static-1.4026",
      "HubStyleTokens": "static-2.11316",
      "I18n": "static-7.1598",
      "jasmine-runner": "static-1.6343",
      "quartz": "static-1.6831",
      "react": "static-7.183",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.485",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6006",
      "enviro": "static-4.416",
      "hs-promise-rejection-tracking": "static-1.5433",
      "PortalIdParser": "static-2.377",
      "raven": "static-3.5768",
      "raven-hubspot": "static-1.6075",
      "bend-plugin-trellis-migration": "static-1.3301",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17802",
      "cv-backend-services": "static-1.1530",
      "hub-http": "static-1.6092",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4526",
      "quartz-config": "static-1.609",
      "quartz-core": "static-1.6050",
      "transmute": "static-2.85",
      "HeadJS": "static-2.732",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7662",
      "framer-motion": "static-1.69",
      "hs-test-utils-bend-plugin": "static-1.2994",
      "msw": "static-1.39",
      "react-redux": "static-7.69",
      "redux": "static-4.16",
      "testing-library": "static-1.149",
      "foundations-theming": "static-1.4283",
      "i18n-data": "static-1.218",
      "metrics-js": "static-1.9512",
      "moment-timezone": "static-5.80",
      "react-utils": "static-2.5242",
      "jasmine": "static-4.4198",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.63",
      "styled-components": "static-2.87",
      "UIComponents": "static-3.8263",
      "visitor-ui-component-library-icons": "static-1.5817",
      "bender-build-tools": "static-1.3025",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4524",
      "apollo-stack-hubspot": "static-3.83",
      "classnames": "static-2.10",
      "cssUtils": "static-1.764",
      "customer-data-objects": "static-1.7527",
      "customer-data-ui-utilities": "static-1.9697",
      "data-fetching-client": "static-1.9549",
      "FileManagerCore": "static-1.38659",
      "FileManagerLib": "static-1.38800",
      "foundations-assets": "static-1.4713",
      "graphql": "static-1.79",
      "hs-promise-utils": "static-1.5468",
      "hubspot-apollo-client": "static-1.4752",
      "icons": "static-2.637",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.96",
      "rpc-client-utils": "static-1.4517",
      "salesImages": "static-1.522",
      "timezone-utils": "static-2.5117",
      "ui-gdpr-components": "static-1.10221",
      "ts-schema": "static-1.3974",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.816",
      "hubspotter-http": "static-1.4547",
      "mobile-manifest-mixins": "static-1.506",
      "module-federation": "static-1.20",
      "quartz-auth": "static-1.506",
      "quartz-head": "static-1.496",
      "quartz-i18n": "static-1.506",
      "quartz-routing": "static-1.261",
      "quartz-test": "static-1.506",
      "quartz-tracking": "static-1.210",
      "quick-fetch": "static-1.3807",
      "react-rhumb": "static-1.16525",
      "ui-fonts": "static-1.578",
      "usage-tracker-container": "static-1.7199",
      "usage-tracker-core": "static-1.7059",
      "bend-plugin-foundations-components": "static-1.3931",
      "floating-ui": "static-1.53",
      "foundations-theming-specialty": "static-1.1999",
      "hs-story-utils": "static-1.9300",
      "tanstack-table": "static-1.52",
      "trellis-assets": "static-1.1424",
      "ui-images": "static-2.1124",
      "bend-plugin-foundations-theming": "static-1.2766",
      "foundations-theming-base": "static-1.3268",
      "stylex": "static-1.29",
      "HubStyle": "static-2.11624",
      "sassPrefix": "static-1.153",
      "inbound-db-properties-service-client": "static-1.3740",
      "property-translator": "static-1.5281",
      "react-dnd-compat": "static-1.4492",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8575",
      "audio-components": "static-1.5716",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.23160",
      "FileManagerImages": "static-1.36311",
      "foundations-components-legacy": "static-1.687",
      "immerable": "static-1.4026",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8794",
      "urlinator": "static-1.4405",
      "video-components": "static-1.12809",
      "video-data-lib": "static-1.34464",
      "video-embed": "static-1.35298",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.211",
      "chirp-fetch": "static-1.1755",
      "hub-http-shared-msw-handlers": "static-1.9655",
      "hubspotter-http-shared-msw-handlers": "static-1.9653",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4895",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20652",
      "ContentUtils": "static-1.67855",
      "copilot-toolkit": "static-1.10739",
      "sanitize": "static-1.4347",
      "sanitize-text": "static-1.8018",
      "content-assistance-lib": "static-1.7553",
      "usage-tracker": "static-1.7209",
      "ui-addon-iframeable": "static-1.8921",
      "video-components-external": "static-1.10806",
      "unified-auth-core-lib": "static-1.589",
      "content-icons-ui": "static-1.2188",
      "social-insights-client-types": "static-1.21623",
      "SharedI18nStrings": "static-1.181",
      "outpost": "static-1.4071",
      "amplitude-session-replay-browser": "static-1.57",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4681",
      "integrations-lib": "static-1.15657",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5467",
      "magpie-types": "static-1.4927",
      "simple-logging-lib": "static-1.2923",
      "superstore": "static-1.4641",
      "ui-addon-video-player": "static-1.8568",
      "ui-coaching-tips": "static-1.28145",
      "navigation-messaging": "static-1.6864",
      "content-media-composition-data-lib": "static-1.11754",
      "content-media-compositions": "static-2.15761",
      "idb-keyval": "static-1.41",
      "media-bridge-lib": "static-1.18698",
      "fsm": "static-1.3604",
      "flux-actions": "static-1.323",
      "frontend-preferences-client": "static-1.7797",
      "integrations-error-boundary-lib": "static-1.13072",
      "integrations-tracking-lib": "static-1.5464",
      "laboratory-lib": "static-3.7033",
      "native-integrations-shared-strings": "static-1.7659",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10247",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11019",
      "ui-shepherd-react": "static-3.10019",
      "unified-auth": "static-1.308",
      "reactive-lib": "static-1.597",
      "growth-onboarding-feedback-components": "static-1.6454",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2874",
      "foundations-components-test-utils": "static-1.5145",
      "react-dlb": "static-1.74",
      "crm-record-cards-service-types": "static-1.3511",
      "framework-data-schema-resolvers": "static-1.6747",
      "location-customization-utils-lib": "static-1.8794",
      "batch-promise": "static-1.1425",
      "conditional-properties-service-client": "static-1.3692",
      "crm-pipelines-api-client-types": "static-1.4036",
      "framework-builder-read-service-client": "static-1.3902",
      "framework-data-schema-quick-fetch": "static-1.6652",
      "inbound-db-meta-service-client": "static-1.3484",
      "multi-currency-client-types": "static-1.3584",
      "persist-promise": "static-1.3582"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26137",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12618",
      "head-dlb": "/head-dlb/static-1.4884",
      "hs-test-utils": "/hs-test-utils/static-1.7883",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4026",
      "HubStyleTokens": "/HubStyleTokens/static-2.11316",
      "I18n": "/I18n/static-7.1598",
      "jasmine-runner": "/jasmine-runner/static-1.6343",
      "quartz": "/quartz/static-1.6831",
      "react": "/react/static-7.183",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6006",
      "enviro": "/enviro/static-4.416",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
      "PortalIdParser": "/PortalIdParser/static-2.377",
      "raven": "/raven/static-3.5768",
      "raven-hubspot": "/raven-hubspot/static-1.6075",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17802",
      "cv-backend-services": "/cv-backend-services/static-1.1530",
      "hub-http": "/hub-http/static-1.6092",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4526",
      "quartz-config": "/quartz-config/static-1.609",
      "quartz-core": "/quartz-core/static-1.6050",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.732",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7662",
      "framer-motion": "/framer-motion/static-1.69",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.69",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.149",
      "foundations-theming": "/foundations-theming/static-1.4283",
      "i18n-data": "/i18n-data/static-1.218",
      "metrics-js": "/metrics-js/static-1.9512",
      "moment-timezone": "/moment-timezone/static-5.80",
      "react-utils": "/react-utils/static-2.5242",
      "jasmine": "/jasmine/static-4.4198",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.63",
      "styled-components": "/styled-components/static-2.87",
      "UIComponents": "/UIComponents/static-3.8263",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5817",
      "bender-build-tools": "/bender-build-tools/static-1.3025",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4524",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.764",
      "customer-data-objects": "/customer-data-objects/static-1.7527",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9697",
      "data-fetching-client": "/data-fetching-client/static-1.9549",
      "FileManagerCore": "/FileManagerCore/static-1.38659",
      "FileManagerLib": "/FileManagerLib/static-1.38800",
      "foundations-assets": "/foundations-assets/static-1.4713",
      "graphql": "/graphql/static-1.79",
      "hs-promise-utils": "/hs-promise-utils/static-1.5468",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4752",
      "icons": "/icons/static-2.637",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.96",
      "rpc-client-utils": "/rpc-client-utils/static-1.4517",
      "salesImages": "/salesImages/static-1.522",
      "timezone-utils": "/timezone-utils/static-2.5117",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10221",
      "ts-schema": "/ts-schema/static-1.3974",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.816",
      "hubspotter-http": "/hubspotter-http/static-1.4547",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
      "module-federation": "/module-federation/static-1.20",
      "quartz-auth": "/quartz-auth/static-1.506",
      "quartz-head": "/quartz-head/static-1.496",
      "quartz-i18n": "/quartz-i18n/static-1.506",
      "quartz-routing": "/quartz-routing/static-1.261",
      "quartz-test": "/quartz-test/static-1.506",
      "quartz-tracking": "/quartz-tracking/static-1.210",
      "quick-fetch": "/quick-fetch/static-1.3807",
      "react-rhumb": "/react-rhumb/static-1.16525",
      "ui-fonts": "/ui-fonts/static-1.578",
      "usage-tracker-container": "/usage-tracker-container/static-1.7199",
      "usage-tracker-core": "/usage-tracker-core/static-1.7059",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3931",
      "floating-ui": "/floating-ui/static-1.53",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
      "hs-story-utils": "/hs-story-utils/static-1.9300",
      "tanstack-table": "/tanstack-table/static-1.52",
      "trellis-assets": "/trellis-assets/static-1.1424",
      "ui-images": "/ui-images/static-2.1124",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
      "foundations-theming-base": "/foundations-theming-base/static-1.3268",
      "stylex": "/stylex/static-1.29",
      "HubStyle": "/HubStyle/static-2.11624",
      "sassPrefix": "/sassPrefix/static-1.153",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
      "property-translator": "/property-translator/static-1.5281",
      "react-dnd-compat": "/react-dnd-compat/static-1.4492",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8575",
      "audio-components": "/audio-components/static-1.5716",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.23160",
      "FileManagerImages": "/FileManagerImages/static-1.36311",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.687",
      "immerable": "/immerable/static-1.4026",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8794",
      "urlinator": "/urlinator/static-1.4405",
      "video-components": "/video-components/static-1.12809",
      "video-data-lib": "/video-data-lib/static-1.34464",
      "video-embed": "/video-embed/static-1.35298",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.211",
      "chirp-fetch": "/chirp-fetch/static-1.1755",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9655",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9653",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4895",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20652",
      "ContentUtils": "/ContentUtils/static-1.67855",
      "copilot-toolkit": "/copilot-toolkit/static-1.10739",
      "sanitize": "/sanitize/static-1.4347",
      "sanitize-text": "/sanitize-text/static-1.8018",
      "content-assistance-lib": "/content-assistance-lib/static-1.7553",
      "usage-tracker": "/usage-tracker/static-1.7209",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8921",
      "video-components-external": "/video-components-external/static-1.10806",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.589",
      "content-icons-ui": "/content-icons-ui/static-1.2188",
      "social-insights-client-types": "/social-insights-client-types/static-1.21623",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "outpost": "/outpost/static-1.4071",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4681",
      "integrations-lib": "/integrations-lib/static-1.15657",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5467",
      "magpie-types": "/magpie-types/static-1.4927",
      "simple-logging-lib": "/simple-logging-lib/static-1.2923",
      "superstore": "/superstore/static-1.4641",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28145",
      "navigation-messaging": "/navigation-messaging/static-1.6864",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11754",
      "content-media-compositions": "/content-media-compositions/static-2.15761",
      "idb-keyval": "/idb-keyval/static-1.41",
      "media-bridge-lib": "/media-bridge-lib/static-1.18698",
      "fsm": "/fsm/static-1.3604",
      "flux-actions": "/flux-actions/static-1.323",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7797",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13072",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5464",
      "laboratory-lib": "/laboratory-lib/static-3.7033",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7659",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10247",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11019",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10019",
      "unified-auth": "/unified-auth/static-1.308",
      "reactive-lib": "/reactive-lib/static-1.597",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6454",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2874",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5145",
      "react-dlb": "/react-dlb/static-1.74",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8794",
      "batch-promise": "/batch-promise/static-1.1425",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
      "persist-promise": "/persist-promise/static-1.3582"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26137",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};